<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content with-footer">
        <el-form
          ref="rentForm"
          :model="rent"
          label-width="80px"
          size="small"
          class="box"
        >
          <fieldset class="mgb15">
            <legend>
              {{ $t("text.baseInfo") }}
            </legend>
            <el-row>
              <el-col :span="8">
                <el-form-item
                  :label="
                    rent.type == 'rent'
                      ? $t('rent.serialNo')
                      : $t('clean.serialNo')
                  "
                  :prop="'serialNo'"
                  :rules="[
                    {
                      required: true,
                      validator: validateSerialNo,
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    size="small"
                    v-model.trim="rent.serialNo"
                    :placeholder="$t('prompt.alphabetNumberLine')"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  :label="$t('menu.shops')"
                  :prop="'shopId'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [$t('menu.shops')]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-select
                    v-model="rent.shopId"
                    clearable
                    filterable
                    :disabled="Permit.createOrderFixShopDF()"
                  >
                    <el-option
                      v-for="shop in shops"
                      :key="shop.id"
                      :label="shop.name"
                      :value="shop.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item
                  :label="
                    rent.type == 'rent' ? $t('rent.rentAt') : $t('clean.rentAt')
                  "
                  :prop="'_rentAt'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [
                        rent.type == 'rent'
                          ? $t('rent.rentAt')
                          : $t('clean.rentAt'),
                      ]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-date-picker
                    size="small"
                    v-model="rent._rentAt"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="-"
                    :start-placeholder="
                      $t('rules.startAt', [$t('rent.rentAt')])
                    "
                    :end-placeholder="$t('rules.endAt', [$t('rent.rentAt')])"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset class="mgb15" v-if="rent.type == 'rent'">
            <legend>{{ $t("customer.addressInfo") }}</legend>
            <el-row>
              <el-col :span="8">
                <el-form-item
                  :label="$t('user.name')"
                  :prop="'customerName'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [$t('user.name')]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input v-model="rent.customerName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('user.phone')"
                  :prop="'customerPhone'"
                  label-width="90px"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [$t('user.name')]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input v-model="rent.customerPhone"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('tenant.country')">
                  <el-select v-model="rent.customerCountry" filterable>
                    <el-option
                      v-for="country in countries"
                      :key="country"
                      :label="$t('countries.' + country)"
                      :value="country"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('tenant.province')"
                  :prop="'customerProvince'"
                >
                  <el-input v-model="rent.customerProvince"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('tenant.city')" :prop="'customerCity'">
                  <el-input v-model="rent.customerCity"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <el-form-item
                  :label="$t('tenant.address')"
                  :prop="'customerAddress'"
                >
                  <el-input v-model="rent.customerAddress"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('customer.zipcode')"
                  :prop="'customerZipcode'"
                >
                  <el-input v-model="rent.customerZipcode"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset class="mgb15">
            <legend>{{ $t("text.remark") }}</legend>
            <el-input v-model="rent.remark" type="textarea" :rows="2" />
          </fieldset>
        </el-form>
      </div>
    </div>
    <div class="drawer-footer">
      <el-button
        type="primary"
        size="small"
        plain
        :loading="saveDoing"
        @click="saveSubmit"
        >{{ $t("text.submit") }}</el-button
      >
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Rent from "@/api/rent.js";
import Shop from "@/api/shop.js";
import { countries } from "@/utils/enums.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {},
  data() {
    var validateSerialNo = (rule, value, callback) => {
      const self = this;
      if (value === null || value.trim() === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("rent.serialNo")]))
        );
        return;
      }
      if (!Util.regexAlphabetNumberLine(value)) {
        callback(new Error(this.$t("prompt.regexAlphabetNumberLine")));
        return;
      }
      Rent.findBySerialNo({ serialNo: value }).then(function (res) {
        if (res.data.code === 200 && res.data.entity.id !== self.rent.id) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("rent.serialNo")]))
          );
        } else {
          callback();
        }
      });
    };
    return {
      Util: Util,
      countries: countries,
      validateSerialNo: validateSerialNo,
      rent: {},
      shops: [],
      saveDoing: false,
    };
  },

  computed: {},
  created() {
    const self = this;
    self.loadingStart();
    axios.all([Rent.findById(self.id), Shop.findByTenantId()]).then(
      axios.spread(function (rent, shops) {
        if (rent.data.code === 200) {
          self.rent = rent.data.entity;
          Vue.set(self.rent, "_rentAt", [
            new Date(self.rent.startAt),
            new Date(self.rent.endAt),
          ]);
        } else {
          self.sysError();
        }
        if (shops.status === 200) {
          self.shops = shops.data;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      })
    );
  },
  methods: {
    saveSubmit() {
      const self = this;
      self.$refs.rentForm.validate((valid) => {
        if (valid) {
          self.rent.shopName = self.shops.find(
            (s) => s.id == self.rent.shopId
          ).name;
          self.rent.startAt = Util.formatDate(self.rent._rentAt[0]);
          self.rent.endAt = Util.formatDate(self.rent._rentAt[1]);
          self.saveDoing = true;
          Rent.update(self.rent.id, self.rent).then(function (res) {
            self.saveDoing = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.$emit("updateInfo", self.rent);
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>